import React from "react";
import "../Scss/ContactStyles.scss?v=1.1.3";

import { Typography } from "antd";
// Instalar
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import {
//   Typography, Divider, Modal, Tabs, Input, DatePicker, Button, TimePicker
// } from 'antd';
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { NavLink } from "react-router-dom";
import { FormControl } from "@mui/material";
const { Title, Paragraph, Text } = Typography;

// const useStyles = makeStyles((theme) => ({
//   root: {
//     flexGrow: 1,
//   },
//   "fatherContainer": {
//     marginLeft: "16px",
//     marginRight: "16px",
//   },
//   "menuButton": {
//     margin: "20px auto 10px 30px",
//     // marginLeft: theme.spacing(5)
//   },
//   "title": {
//     flexGrow: 1,
//     marginLeft: theme.spacing(2),
//     marginBottom: "10px",
//     fontSize: "26px",
//     fontWeight: 100,
//     fontFamily: "system-ui",
//     lineHeight: 1.1,
//     color: "#676a6c",
//   },
//   "paragraph": {
//     flexGrow: 1,
//     marginLeft: theme.spacing(5),
//     marginBottom: "10px",
//   },
//   space: {
//     marginLeft: theme.spacing(8),
//     marginTop: "1px",
//     marginBottom: "10px",
//     textAlign: "left",
//     width: "70%",
//   },
// }));

const CrearContacto = () => {

  return (
    <div className={"fatherContainer"}>
      <div className="viewHead">
        <h2 className={"title"}>Crear Contacto</h2>
        <Text className={"paragraph"}>
          <NavLink className="urlDirection" to={"/"}>
            Inicio
          </NavLink>{" "}
          /{" "}
          <NavLink className="urlDirection" to={"/contactos"}>
            Contactos
          </NavLink>{" "}
          / <b>Crear Contacto</b>
        </Text>
      </div>
      <Box
        component="form"
        sx={{
          margin: "auto",
          "& > :not(style)": {
            // textAlign: 'center',
            width: "60%",
          },
        }}
        noValidate
        autoComplete="off"
        className="formMainContainer"
      >
        <TextField
          variant="outlined"
          className="inputForm"
          label="Asignado a"
        />
        <TextField
          variant="outlined"
          className="inputForm"
          label="Abogado por defecto"
        />
        <TextField variant="outlined" className="inputForm" label="Despacho" />
        <TextField variant="outlined" className="inputForm" label="Email" />
        <TextField variant="outlined" className="inputForm" label="Nombre" />
        <TextField variant="outlined" className="inputForm" label="Apellidos" />
        <TextField variant="outlined" className="inputForm" label="Dirección" />
        <TextField variant="outlined" className="inputForm" label="Provincia" />
        <TextField
          variant="outlined"
          className="inputForm"
          label="Código postal"
        />
        <TextField
          variant="outlined"
          className="inputForm"
          label="NIF/Pasaporte"
        />
        <TextField variant="outlined" className="inputForm" label="Teléfono" />
        <TextField variant="outlined" className="inputForm" label="Zona" />
        <TextField
          variant="outlined"
          className="inputForm"
          label="Asociación"
        />
        <TextField
          variant="outlined"
          className="inputForm"
          label="Tipo de proceso"
        />
        <TextField
          variant="outlined"
          className="inputForm"
          label="Observaciones"
        />
      </Box>

      <div className={"space"}>
        <button className={"menuButton" + " " + "redButton"}>
          {" "}
          Cancelar{" "}
        </button>
        <button className={"menuButton" + " " + "greenButton"}>
          {" "}
          Crear Contacto{" "}
        </button>
      </div>
    </div>
  );
};

export default CrearContacto;
